var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationpinsvgrepocom11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00855 0H5.99142C3.91904 0 2.23309 1.68539 2.23309 3.75697C2.23309 5.1149 2.85151 6.90702 4.07117 9.08366C4.97542 10.6974 5.89234 11.9333 5.90152 11.9455C5.92705 11.9798 5.96728 12 6.0099 12C6.01111 12 6.01235 12 6.01356 12C6.05754 11.9988 6.09813 11.9763 6.12253 11.9396C6.13157 11.9259 7.04196 10.5511 7.94007 8.86959C9.15229 6.60001 9.76693 4.87983 9.76693 3.75697C9.76685 1.68536 8.08087 0 6.00855 0ZM7.74335 3.84879C7.74335 4.81011 6.96128 5.59215 5.99996 5.59215C5.03866 5.59215 4.25659 4.81008 4.25659 3.84879C4.25659 2.88749 5.03866 2.10542 5.99996 2.10542C6.96128 2.10542 7.74335 2.88749 7.74335 3.84879Z",
    fill: "#169C50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationpinsvgrepocom11);
export default __webpack_public_path__ + "static/media/locationpinsvgrepocom-1-1.e87ce4af4ef30f769cb0f4cafc55f399.svg";
export { ForwardRef as ReactComponent };